export enum EXCLUDEDBRANCHES {
  MKMGRIMSBYHOME = 99_990_001,
}

export const excludedBranches = Object.values(EXCLUDEDBRANCHES).filter(
  (branchId) => typeof branchId === "number",
) as number[];
